import { useEffect, useState } from 'react'

function msUntilEndOfDay(): number {
  const now = new Date()
  const end = new Date(now)
  end.setHours(23, 59, 59, 999)
  return Math.max(0, end.getTime() - now.getTime())
}

function pad(value: number): string {
  return value.toString().padStart(2, '0')
}

/** Conto alla rovescia fino alla mezzanotte: l'offerta è valida solo per oggi. */
export function useCountdown(): { hours: string; minutes: string; seconds: string } {
  const [remaining, setRemaining] = useState(msUntilEndOfDay)

  useEffect(() => {
    const id = window.setInterval(() => setRemaining(msUntilEndOfDay()), 1000)
    return () => window.clearInterval(id)
  }, [])

  const totalSeconds = Math.floor(remaining / 1000)
  return {
    hours: pad(Math.floor(totalSeconds / 3600)),
    minutes: pad(Math.floor((totalSeconds % 3600) / 60)),
    seconds: pad(totalSeconds % 60),
  }
}
